<!-- Выбранные расходы и добавление через селект -->
<template>
  <BaseFormSection title="Связанные расходы" icon="payment" :count="selectedIds.length" :columns="1">
    <RecordListRelatedSelect :model-value="modelValue" :vehicle-id="vehicleId" :initial-records="expenses"
      :disabled="disabled" :fetch-records="fetchRecords" :record-label="recordLabel" placeholder="Добавить расход"
      @update:model-value="$emit('update:modelValue', $event)">
      <template #record="{ record, remove }">
        <ExpenseRelatedCard :expense="record" removable :disabled="disabled" @remove="remove" />
      </template>
    </RecordListRelatedSelect>
  </BaseFormSection>
</template>
<script>
import RecordListRelatedSelect from "@/components/RecordList/RelatedSelect.vue";
import ExpenseRelatedCard from "@/components/Expense/RelatedCard.vue";
import { useExpenseStore } from "@/stores/expenseStore";
import { associationListForControl } from "@/utils/associationListUtils";
import { formatBigNumber } from "@/utils/numberUtils";
export default {
  name: "FleetRepairPaymentSection",
  components: { RecordListRelatedSelect, ExpenseRelatedCard },
  props: {
    modelValue: { type: Array, default: undefined },
    expenses: { type: Array, default: () => [] },
    vehicleId: { type: [Number, String], default: null },
    disabled: Boolean,
    repairId: { type: [Number, String], default: null },
  },
  emits: ["update:modelValue"],
  computed: {
    selectedIds() { return associationListForControl(this.modelValue); },
  },
  methods: {
    fetchRecords(vehicleId, search) { return useExpenseStore().fetchRepairExpenseOptions(vehicleId, search, this.repairId); },
    recordLabel(expense) {
      return ["№" + expense.id, expense.expense_category?.name, formatBigNumber(expense.amount) + " ₽", expense.comment].filter(Boolean).join(" · ");
    },
  },
};
</script>
